import CreditType from './CreditType';

export default class CreditHeading {
  public profileId: string;
  public creditType: CreditType;
  public isHidden: boolean;
  public position: number;
  public orderByDate: boolean;
}
